import React from 'react';
import { Host } from '../../../Host';
import { TaskData } from '../../../api/endpoints/tasks';
import { BoardBadgeButton } from './BoardBadgeButton';

export interface TaskBoardCellProps {
    task: TaskData;
}

export const TaskBoardCell = React.memo<TaskBoardCellProps>(({ task }) => {
    const { board, ref } = task;
    if (!board) return null;
    return <BoardBadgeButton label={board.label} href={`${Host.baseUrl}/${board.id}?camera=auto:${ref}`} />;
});
